<template>
	<div>

		<b-modal ref="save-modal" title="Save Scenario" v-model="save">
			<b-form inline>
				<label class="mr-sm-2" for="saveName">Rename</label>
				<b-input class="mb-2 mr-sm-2 mb-sm-0 w-75" id="saveName" v-model="save_name" />
			</b-form>

			<div slot="modal-footer" class="w-100">

				<button type="button" class="btn btn-dark float-left" @click="save=false">Cancel</button>
				<button type="submit" class="btn btn-secondary float-right" @click="saveAction">Save</button>
			</div>


		</b-modal>

	</div>


</template>
<script>

	import { get } from 'idb-keyval';

	export default {
		name: 'SaveControl',
		data() {
			return {
				save_name: null
			}
		},
		computed: {
			workers() { return this.$store.state.workers },
			map() { return this.$store.state.map.map },
			location() { return this.$store.state.location},
			load: {
				get() {
					return this.$store.state.load
				},
				set(value) {
					this.$store.commit('setState', ['load', value])
				}
			},
			assetsLayer() { return this.$store.state.map.assetsLayer},
			save: {
				get() {
					return this.$store.state.save
				},
				set(value) {
					this.$store.commit('setState', ['save', value])
				}
			},
		},
		watch: {
			load: {
				handler() {
					if (this.load != false) {
						this.loadState();
					}
				}
			},
			save() {
				this.saveModal = this.save
			}
		},
		methods: {
			async loadState() {
				let features = this.assetsLayer.getFeatures();
				for (let i in features) {
					let feature = features[i];
					if (feature instanceof ol.Sprite) {
						this.assetsLayer.removeFeature(feature);
					}
				}

			//	let data = JSON.parse(localStorage.getItem(this.load));
				let data = await get(this.load);
				let map = data.map;
				if (map.zoom != undefined) this.map.getView().setZoom(map.zoom);
				if (map.center != undefined) this.map.getView().setCenter(map.center);
				if (map.rotation != undefined) this.map.getView().setRotation(map.rotation);


			},
			saveAction() {
				this.$store.dispatch('save', {save_name: this.save_name });
				this.save = false;
			}
		},
		mounted() {
			this.save_name = this.$store.state.save_file ? this.$store.state.save_file : this.location.title + ' ' + this.moment().format('M.D.YY')
		}
	}
</script>
